import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { CargoCategory } from 'src/app/core/models/cargo-category';
import { CargoCategoryService } from 'src/app/core/services/general/cargo-category.service';

@Component({
  selector: 'app-cargo-category-input',
  templateUrl: './cargo-category-input.component.html',
  styleUrls: ['./cargo-category-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CargoCategoryInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: CargoCategoryInputComponent,
    },
  ],
})
export class CargoCategoryInputComponent {
  @Input()
  title = "Select Cargo Category...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public cargoCategoriesList: Array<CustomSelectOption> = [];

  constructor(
    private cargoCategoryService: CargoCategoryService,
  ) {
    this.cargoCategoryService
      .all()
      .subscribe((res: Array<CargoCategory>) => {
        this.cargoCategoriesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.cargoCategoriesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
